import { useState } from 'react'

import {
  CannedJobMotorLaborEntry,
  LaborOverridePlaceholderTypeEnum,
  ServiceExpanded
} from '../../../sdk'
import { CannedJobMotorOptions } from '../ServiceStepper/CannedJobMotorOptions'

export const SelectMultiLabor = ({
  services,
  motorLabors,
  submitCallback
}: {
  services: ServiceExpanded[]
  motorLabors: CannedJobMotorLaborEntry[]
  submitCallback: () => void
}) => {
  const [index, setIndex] = useState(0)
  const laborOverrides = services.flatMap((service) =>
    service.laborOverrides!.filter(
      (l) => l.placeholderType === LaborOverridePlaceholderTypeEnum.MotorLabor
    )
  )
  const handleSkip = () => {
    if (index === laborOverrides.length - 1) {
      submitCallback()
    } else {
      setIndex(index + 1)
    }
  }
  return (
    <>
      {laborOverrides.map(
        (laborOverride, i) =>
          i === index && (
            <CannedJobMotorOptions
              key={i}
              motorLabor={
                motorLabors.find((m) => m.id === laborOverride.placeholderId)!
              }
              laborOverride={laborOverride}
              handleSkip={handleSkip}
              submitCallback={handleSkip}
            />
          )
      )}
    </>
  )
}
